enum LoadingState {
  LOADING,
  ERROR,
  LOADED
}

export default LoadingState
